module.exports = __webpack_public_path__ + "media/images/amenities_icons/ping_pong_table-aa48d377c59ad0a19c2a5ed68f362e38.svg";